/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import once from 'lodash/once';

import { clientErrorTracker } from '@spotahome/soyuz/client';
import { ImageCarousel } from '@spotahome/ui-library';

import { SkeletonSlider } from '../Skeleton';

import { getImageTrackIndex, findImageTrack } from './utils/sliderAdapter';
import ImageMosaic from './ImageMosaic';

import './MainSliderItem.scss';

const trackEmptyImage = once(() => {
  clientErrorTracker.error({
    error: new Error('Listing images are missing'),
    source: 'Listing-MainSliderItem'
  });
});

const MainSliderItem = ({ tracks = [], onItemClick, deviceType }) => {
  const createOpenSliderHandler = () => {
    const trackClickedId = getImageTrackIndex(tracks);

    onItemClick(trackClickedId);
  };

  const imageTrack = findImageTrack(tracks);
  const isImageTrackEmpty = !imageTrack?.items.length;

  useEffect(() => {
    if (isImageTrackEmpty) {
      trackEmptyImage();
    }
  }, [isImageTrackEmpty]);

  if (isImageTrackEmpty) {
    return <SkeletonSlider />;
  }

  const hasThreeOrMoreImages = imageTrack?.items?.length >= 3;

  return deviceType === 'desktop' && hasThreeOrMoreImages ? (
    <ImageMosaic
      imageTrack={imageTrack.items}
      onClick={createOpenSliderHandler}
    />
  ) : (
    <div
      data-test="main-slider-image-container"
      className="main-slider-image ga-slider-main-image"
    >
      <ImageCarousel
        onImageClick={createOpenSliderHandler}
        items={imageTrack.items}
        chevronStyle="big"
        preloadRange={0}
        keepHeightWhileLoading
        withBackgroundChevrons
        className="main-slider-image__carousel"
      />
    </div>
  );
};

MainSliderItem.propTypes = {
  tracks: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          caption: PropTypes.string,
          src: PropTypes.string.isRequired
        })
      ),
      isHidden: PropTypes.bool
    })
  ),
  onItemClick: PropTypes.func.isRequired,
  deviceType: PropTypes.oneOf(['smartphone', 'tablet', 'desktop']).isRequired
};

export default MainSliderItem;
